import { useTranslation } from 'react-i18next';

import { SimpleTooltip } from '@/components/ui/simple-tooltip';

const MAX_VISIBLE_INDUSTRIES = 2;

/**
 * Renders a list of industries, showing up to MAX_VISIBLE_INDUSTRIES with a
 * tooltip listing the rest ("x, y +N more").
 */
export const IndustriesValue = ({ value }: { value: string }) => {
  const { t } = useTranslation('authenticated.projects');
  const industries = value
    .split(', ')
    .map(s => s.trim())
    .filter(Boolean);

  if (industries.length <= MAX_VISIBLE_INDUSTRIES) {
    return <span>{value}</span>;
  }

  const visible = industries.slice(0, MAX_VISIBLE_INDUSTRIES);
  const hidden = industries.slice(MAX_VISIBLE_INDUSTRIES);

  return (
    <span>
      {visible.join(', ')}
      <SimpleTooltip content={<p>{hidden.join(', ')}</p>}>
        <span className="cursor-default underline">
          {t('details.tabs.changes.valueDisplay.andMore', { count: hidden.length })}
        </span>
      </SimpleTooltip>
    </span>
  );
};
